// U-Guarantee-Slider
  document.addEventListener("DOMContentLoaded", function(){
    new Swiper(".guaranteeswiper", {
      slidesPerView: 4,
      spaceBetween: 20,
      loop: true,
      pagination: {
        el: ".guaranteeswiper .swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        320: { slidesPerView: 1 },
        769: { slidesPerView: 1 },
        1024: { slidesPerView: 4 }
      }
    });
  });
// U-Reviews
    document.addEventListener('DOMContentLoaded', function () {
    var el = document.querySelector('.u-reviews-swiper');
    if(!el) return;
    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true
      }
    });
  });
// U-Announcement-Bar
    document.addEventListener("DOMContentLoaded", function () {
    new Swiper(".announcement-swiper", {
      slidesPerView: 1,              
      centeredSlides: false,
      spaceBetween: 20,
      breakpoints: {
        768: {
          slidesPerView: 3,           
          centeredSlides: false,
        }
      }
    });
  });
// U-Image-SLider
document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".u-image-swiper", {
    slidesPerView: 5,
    spaceBetween: 10,
    loop: true,
    navigation: {
      nextEl: ".u-image-slider .swiper-button-next",
      prevEl: ".u-image-slider .swiper-button-prev",
    },
    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 8,
      },
      888: {
        slidesPerView: 4,
        spaceBetween: 10,
      },      
      1000: {
        slidesPerView: 5,
        spaceBetween: 10,
      },
    },
  });
});


function toggleProductInCart(checkbox) {
    var productId = checkbox.value;
    console.log('Product ID:', productId);

    if (checkbox.checked) {
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                id: productId,
                quantity: 1
            },
            dataType: 'json',
            success: function(response) {
                console.log('Added to cart:', response);
                reloadDivContent("mdata-cart-total");
            },
            error: function(XMLHttpRequest, textStatus) {
                console.error('Error adding to cart:', textStatus, XMLHttpRequest.responseJSON);
            }
        });
    } else {
        // Handle removing the product from the cart
        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
                id: productId,
                quantity: 0
            },
            dataType: 'json',
            success: function(response) {
                console.log('Removed from cart:', response);
                reloadDivContent("mdata-cart-total");
            },
            error: function(XMLHttpRequest, textStatus) {
                console.error('Error removing from cart:', textStatus, XMLHttpRequest.responseJSON);
            }
        });
    }
}

// Reload the content of a div with a specific ID using jQuery
function reloadDivContent(divId) {
  console.log("Reloading Div.....")
  $.get(window.location.href, function(data) {
    var newContent = $(data).find('#' + divId).html();
    $('#' + divId).html(newContent);
  });
  console.log("Reloaded Div.....")
  
}

document.addEventListener("DOMContentLoaded", function () {
    document.querySelector(".product-form__add-btn")?.addEventListener("click", function () {
        setTimeout(() => {
            let shippingCheckbox = document.querySelector("#mshipping-toggle-input");
            if (shippingCheckbox && !shippingCheckbox.checked) {
                shippingCheckbox.checked = true;
                shippingCheckbox.dispatchEvent(new Event("change", { bubbles: true }));
            }
        }, 3000);
    });
});

document.addEventListener('DOMContentLoaded', function() {
  function aggiornaData() {
    const doubleuspsElement = document.querySelector('.doubleusps');
    
    if (!doubleuspsElement) {
      console.error('Error: .doubleusps element not found');
      return;
    }
    const giorniDellaSettimana = doubleuspsElement.dataset.giorni.split(',');
    const mesi = doubleuspsElement.dataset.mesi.split(',');
    const nDays = window.nDays || 0;

    const ora = new Date();
    const futureDate = new Date(ora);
    futureDate.setDate(ora.getDate() + nDays); 

    const dataFormattata = `${giorniDellaSettimana[futureDate.getDay()]}, ${futureDate.getDate()} ${mesi[futureDate.getMonth()]}`;
    
    let cstmDate = document.getElementById('cstmdate');
    if (cstmDate) {
      cstmDate.innerText = dataFormattata;
    }

    const msFinoAllaMezzanotte = new Date(ora.setHours(24, 0, 0, 0)) - ora;
    setTimeout(() => {
      aggiornaData();
      setInterval(aggiornaData, 24 * 60 * 60 * 1000);
    }, msFinoAllaMezzanotte);
  }

  aggiornaData();
});


initslided();

$(document).on('shopify:section:load', function(event) {
  initslided();
});

$(document).on('shopify:section:unload', function(event) {
  initslided();
});

function initslided() {
  $('.u-trustpilot-slider').slick({
    infinite: false,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: true,
    autoplaySpeed: 30000,
    arrows: true,
    prevArrow:"<button type='button' class='slick-prev Mtp-left'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z'/></svg></button>",
    nextArrow:"<button type='button' class='slick-next Mtp-right'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z'/></svg></button>",
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 575,
        settings: {
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}